export const workflowComments = {
  createTitle: "Kommentar erstellen",
  editTitle: "Kommentar aktualisieren",
  createdText: "Kommentar wurde erstellt",
  updatedText: "Kommentar wurde aktualisiert",
  inputPlaceholder: "Bitte geben Sie Ihren Kommentartext hier ein"
};
